import { useEffect } from 'react';

let openModalCount = 0;

const useModalScrollLock = (isOpen: boolean) => {
  useEffect(() => {
    const html = document.documentElement;

    if (isOpen) {
      openModalCount++;

      if (openModalCount === 1) {
        html.style.overflow = 'hidden';
      }
    }

    return () => {
      if (isOpen) {
        openModalCount--;

        if (openModalCount === 0) {
          html.style.overflow = '';
        }
      }
    };
  }, [isOpen]);
};

export default useModalScrollLock;
